export default __webpack_public_path__ + "901c20ccd5481606827792935d4d5073.png";